export const COLORS = {
  backgroundColorDarkTheme: 'var(--app-bg)',
  tableBackgroundColor: 'var(--app-surface-1)',
  tableHeaderColor: 'var(--app-surface-header)',
  borderColorDarkTheme: 'var(--app-table-border)',
  fontColorDarkTheme: 'var(--app-text)',
};

export const STATUS_CONFIG: Record<string, { label: string; color: 'success' | 'warning' | 'error' }> = {
  Success: { label: 'Download OK', color: 'success' },
  InvalidPayload: { label: 'Payload inválido', color: 'warning' },
  DeviceNotFound: { label: 'Dispositivo não vinculado', color: 'error' },
  SendFailed: { label: 'Falha no download', color: 'error' },
  UnexpectedError: { label: 'Erro inesperado', color: 'error' },
};
